export enum CloneRepeatType {
    Undefined = 0,
    Day = 1,
    Week = 2,
    Month = 3
}
